module.exports = __webpack_public_path__ + "img/lexileIcon.932fcadf.png";